import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/patients/$patientId')({
  component: Outlet,
  loader: () => ({ crumb: 'Patient' }),
});
